import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plain",
  "use": "icon-plain-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-plain\"><path d=\"M11.856 561.048l289.632 129.44 559.456-523.88-491.04 564.752 371.48 149.88c8.952 3.4 19.176-1.36 22.376-10.904v-.68L1023.984.376 10.576 526.992c-8.96 4.776-12.152 15.672-8.32 25.208 2.56 4.088 5.76 7.496 9.6 8.856zm357.408 462.568L513.76 858.08l-144.496-62.672v228.216z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol